import React from "react";

import MainContext from "../MainContext";
import Constants from "../Constants";

/*
                    <div className="swap swap-description" 
                        style={{
                        width: "100%",
                        paddingLeft: "0",
                        display: "grid",
                        gridTemplateColumns: "1fr 30fr 2fr",
                        gridColumn: "1/-1",
                        alignItems: "center",
                        backgroundColor: "#dfe6f5",
                        color: "#888",
                        borderLeft: "1px solid white",
                        borderRight: "1px solid white",
                        // borderTop: "2px solid black"
                    }}>
*/

//
//
//
function getFromUnfilledLookup(currentTrip){

    const key = currentTrip.TripNumber + currentTrip.SchedDepTime;
    const lookupString = localStorage.getItem("__UNFILLED_LOOKUP__");

    // console.log("LOOKUP KEY", key);
    // console.log("LOOKUP STRING", lookupString);

    if(lookupString){
        const lookup = JSON.parse(lookupString);
        if(lookup){
            // console.log("LOOKUP EXISTS", lookup, "VALUE", lookup[key]);
            return lookup[key];
        }
    }

    return "";
}
//
//
//

export default class TripSwapDisplay extends React.Component {

    static contextType = MainContext;

    render(){

        const nonStarter = this.context.user.access !== Constants.access.starter;

        const {isFilled, isUsed, tripTo, tripFrom, currentTrip} = this.props;

        if(isFilled){   
            // console.log("TRIP SWAP DISPLAY", currentTrip, tripFrom, tripTo);
        }

        if(tripTo || tripFrom){ 
            // console.log("TRIP TO", tripTo, tripFrom, currentTrip);
        }

        let originalId = currentTrip.run_id_original;
        if(!originalId){
            const unfilled = getFromUnfilledLookup(currentTrip); 
            // console.log("LOOKUP VALUE RETURNED?", unfilled);
            originalId = originalId || unfilled;
        }

        const departureTime = tripFrom && tripFrom.departure && (tripFrom.departure.substring(tripFrom.departure.indexOf(" ")));

        return (
            <>
            {
                isFilled
                ? <>
                        <div style={{
                            position: "absolute",
                            left: "0px",
                            color: "black",
                            background: "white",
                            opacity: "0.5",
                            padding: "0 4px",
                            display: "flex",
                            height: "1.8rem",
                            alignItems: "center"
                        }}>
                            Original Trip Run: {originalId}
                        </div>
                        {
                            nonStarter
                            ? <div className="switch-display-cell"></div>
                            : null
                        }
                        <div className="switch-display-cell" style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 3fr 2fr 4fr",
                            justifyItems: "start",
                            alignItems: "center",
                            padding: "0px 0 2px 32px"
                        }}>
                            <div></div>
                            <div>
                                <b>{departureTime}</b>
                            </div>
                            <div>
                                Route: <b>{tripFrom.route}</b>
                            </div>
                            <div style={{fontSize: "0.9rem", display: "flex", alignItems: "center", position: "relative"}}>
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "max-content",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <i className="fas fa-arrow-circle-left"></i>
                                    <div style={{fontWeight: "500", fontSize: "0.8rem", paddingLeft: "8px", marginBottom: "0.15rem"}}>
                                        Trip this bus was originally assigned to
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="switch-display-cell">
                            {/* <div style={{
                                backgroundColor: "white", 
                                padding: "4px", 
                                borderRadius: "5px", 
                                textAlign: "center", 
                                margin: "7px -13px 7px 4px",
                                display: "flex",
                                flexDirection: "column",
                            }}>
                                <span style={{fontSize: "0.5rem"}}>
                                    taken from bus
                                </span>
                                <span style={{fontSize: "0.7rem"}}>
                                    #{currentTrip.previousBusId}
                                </span>
                            </div> */}
                        </div>
                        {/* <button style={{
                            padding: "6px",
                            marginLeft: "1vw"
                        }} onClick={() => this.props.undoSwitch(this.props.currentTripNumber, tripFrom.TripNumber)}>undo</button> */}
                </>
                : null
            }
            {
                false && isUsed // deprecated
                ? <>
                    <div className="swap swap-description" 
                        style={{
                        width: "100%",
                        paddingLeft: "0",
                        display: "grid",
                        gridTemplateColumns: "1fr 30fr 2fr",
                        gridColumn: "1/-1",
                        alignItems: "center",
                        backgroundColor: "#f5a6a6",
                        color: "#888",
                        borderLeft: "1px solid white",
                        borderRight: "1px solid white"
                    }}>
                        <div>
                            {/* <i class="fas fa-random"></i> */}
                        </div>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 3fr 2fr 4fr",
                            justifyItems: "start",
                            alignItems: "center",
                            padding: "8px 0 8px 32px"
                        }}>
                            <div>
                                Run: <b>{tripTo.run}</b>
                                <span style= {{
                                        marginLeft: "1vw",
                                        backgroundColor: "white",
                                        padding: "0.4vw 1.2vw",
                                        borderRadius: "10px"
                                    }}
                                >
                                    <i className="fas fa-random"></i>
                                </span>
                            </div>
                            <div>
                                <b>{tripTo.departure}</b>
                            </div>
                            <div>
                                Route: <b>{tripTo.route}</b>
                            </div>
                            <div style={{fontWeight: "500", fontSize: "0.9rem", display: "flex", alignItems: "center", color: "black"}}>
                                <div style={{backgroundColor: "white", padding: "4px", borderRadius: "5px"}}>
                                    Bus # {tripTo.busID}
                                </div>
                                <div style={{paddingLeft: "8px"}}>
                                    This bus has not been used
                                </div>
                            </div>
                        </div>

                        <div></div>
                        {/* <button style={{
                            padding: "6px",
                            marginLeft: "1vw"
                        }} onClick={() => this.props.undoSwitch(this.props.currentTripNumber, tripFrom.TripNumber)}>undo</button> */}
                    </div>
                </>
                : null
            }
            </>
        );
    }
}